export enum QueryParams {
  ModuleType = 'module:type',
}
